import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "flex" }
const _hoisted_3 = { class: "text-sm font-medium" }

import { ExclamationIcon } from "@heroicons/vue/solid";
import { XCircleIcon } from "@heroicons/vue/solid";
import { CheckCircleIcon } from "@heroicons/vue/solid";
import { InformationCircleIcon } from "@heroicons/vue/solid";

//Types
import { SizesKeys } from "@/types/sizes.type";
import type { SizesKeysType } from "@/types/sizes.type";

import { variants, sizes, VariantKeys } from "./Alert";
import type { VariantsType } from "./Alert";

//Props

export default /*@__PURE__*/_defineComponent({
  __name: 'BaseAlert',
  props: {
    id: {},
    variant: { default: VariantKeys.primary },
    size: { default: SizesKeys.default },
    full: { type: Boolean, default: true },
    block: { type: Boolean, default: false },
    title: { default: "" },
    message: { default: "" }
  },
  setup(__props: any) {

//Icon
const props = __props;

const GetVariantIcon = () => {
  const variantIcon = {
    [VariantKeys.primary]: undefined,
    [VariantKeys.secondary]: undefined,
    [VariantKeys.error]: XCircleIcon,
    [VariantKeys.warning]: ExclamationIcon,
    [VariantKeys.valid]: CheckCircleIcon,
    [VariantKeys.info]: InformationCircleIcon,
    [VariantKeys.none]: undefined,
  };
  return variantIcon?.[props.variant];
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: _ctx.id,
    class: _normalizeClass([
      _unref(variants)[_ctx.variant]?.default,
      _unref(variants)[_ctx.variant]?.selected,
      _unref(variants)[_ctx.variant]?.classes,
      _unref(sizes)[_ctx.size],
      _ctx.full && 'w-full',
      _ctx.block && 'block',
    ])
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        (_openBlock(), _createBlock(_resolveDynamicComponent(GetVariantIcon()), {
          class: _normalizeClass([[_unref(variants)[_ctx.variant]?.icon], "h-5 w-5"]),
          "aria-hidden": "true"
        }, null, 8, ["class"]))
      ]),
      _createElementVNode("div", {
        class: _normalizeClass([[_unref(variants)[_ctx.variant]?.header], "ml-3"])
      }, [
        _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.title), 1),
        _createElementVNode("div", {
          class: _normalizeClass([[_unref(variants)[_ctx.variant]?.body], "mt-2 text-sm"])
        }, [
          _createElementVNode("p", null, _toDisplayString(_ctx.message), 1)
        ], 2)
      ], 2)
    ])
  ], 10, _hoisted_1))
}
}

})